<template>

	<Outter>
		<ArticleView :article="article"/>
	</Outter>

</template>

<script>


	import ArticleView from "./widget/ArticleView"
	import Article from "../../../common/model/article/Article";
	import Outter from "./Outer.vue";
	export default {
		data () {
			return {
				article: new Article()
			}
		},
		computed: {
			articleId(){
				let aId = this.$route.meta.articleId;
				if (!aId) {
					aId = this.$store.state.route.params.id;
				}
				return aId;
			}
		},
		components: {
			ArticleView,
			Outter
		},
		watch: {
			'$route' (to, from) {
				if (to.path !== from.path) {
					this.article.content = "";
					this.refresh();
				}
			}
		},
		methods: {
			refresh(){
				let that = this;

				this.article.id = this.articleId;
				this.article.httpDetail(null, function () {
					that.article.content = "<p class='italic'>抱歉，该文章不存在，或者已经被删除！</p>";
				});

			}
		},
		mounted(){
			this.refresh();
		}
	}

</script>

<style lang="less" rel="stylesheet/less">
	@import "../../../common/assets/css/global/variables";

	.side-col {

		.title {
			font-size: 19px;
			color: @secondary-color;
			line-height: 34px;
			border-left: 5px @secondary-color solid;
			padding-left: 20px;
			margin: 19px 0 22px 0;
		}

		ul {
			background: #f1f1f1;
			list-style: none;
			margin: 0;
			padding: 0;

			.on {
				color: #fff;
				background-color: #0059ba;
			}

			a {
				display: block;
				height: 50px;
				padding: 0 5px 0 4px;
				text-indent: 30px;
				font-size: 17px;
				color: #333;
				line-height: 50px;
				border-bottom: 1px #e6e6e6 solid;

				&:hover {
					color: #fff;
					background-color: #0059ba;
				}
			}

		}

	}
</style>




// WEBPACK FOOTER //
// Detail.vue?7a3c045e